import { PizzaIngredient } from '@/builders/pizza/dataTransformers/builderTypes';

export const DEFAULT_NO_SAUCE_SELECTION: PizzaIngredient = {
  id: 'no-sauce/portion',
  name: 'No sauce',
  type: 'MODIFIER',
  portion: 'none',
  isPanCrust: false,
  selectedBy: 'user'
};
